import React from "react";
import ChartGPA from "./ChartGPA";
import AcadInfo from "./AcadInfo";
import MyCalendars from "../../../Student/Dashboard/Widget/Calendars/MyCalendars";

export function CAcadStd({studentData}) {
  return (
    <div className="details">
      <div className="row">
        <div className="col-12 col-lg-4 col-xxl-4">
          <div className="mb-4">
            <AcadInfo studentStatus={studentData} />
          </div>
          <div className="card card-custom gutter-b">
            <div className="card-body pt-0 px-0">
              <ChartGPA studentStatus={{ data:studentData }} />
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-8 col-xxl-8">
          <MyCalendars student={studentData} />
        </div>
      </div>
    </div>
  );
}
